import * as React from "react";
import { ActionType } from "../../../../../react-core/Flux/ActionType";
import { RoutingActions } from "../../../../../react-core/Flux/Variables";
import { JsonDateParser } from "../../../../../react-core/Utils/JsonDateParser";
import { ProcessType } from "../../../../../Wrap/Constants/Enums/Client/DashboardFilter/ProcessType";
import { InstructionStatus } from "../../../../../Wrap/Constants/Enums/Domain/InstructionStatus";
import { SubAccountType } from "../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { HierarchyIdHelper } from "../../../../Shared/Common/HierarchyIdHelper";
import { hasRegularPayments } from "../../../../Shared/IST/Components/Shared/Utils";
import {
    AccountContextWizardComponent,
    IAccountContextWizardComponentState,
} from "../../../../Shared/Process/AccountContextWizardComponent";
import { Confirmation } from "../../../../Shared/Process/Process/Confirmation";
import { StepType } from "../../../../Shared/Process/Process/Process";
import { Navigator } from "../../../../Shared/Wizards/Entities/Navigator";
import { getQueryParameters } from "../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { Action } from "../../../Actions/Action";
import { Contents } from "../../../Resoures/Contents";
import {
    AccountRoleStore,
    ClientAccountStore,
    ProductDetailsStore,
    TreasuredAssetsStore
} from "../../../Stroes/Variable";
import { Urls } from "../../../Urls";
import { DocumentsAndDeclarations } from "../Common/Documents/Components/DocumentsAndDeclarations";
import { ClientNameHelper } from "../Common/Helpers/ClientNameHelper";
import { SubAccountTypeHelper } from "../Common/Helpers/SubAccountTypeHelper";
import { processTypeEnum } from "../Common/Resource/Contents";
import { isJointOrTrustAccount } from "../NewBusinessWizard/Components/WrapperSelection/WrapperSelctionHelper";
import { getUrl } from "../PortfolioDashboard/Components/Common/PortfolioDashboardHelper";
import { SPTAction } from "../SinglePaymentTransferWizard/Actions/SPTActions";
import { RegularPaymentAction } from "./Actions/RegularPaymentActions";
import { AdviserCharges } from "./Components/AdviserCharges/AdviserCharges";
import { InvestmentSelectionTool } from "./Components/IST/IST";
import { PaymentsIn } from "./Components/PaymentsIn/PaymentsIn";
import { Review } from "./Components/Review/Review";
import { productMap, RegularPaymentSteppersMap, RegularPaymentActionType } from "./Resource/Contents";
import { ExistingIndexationsStore, ExistingRegularPaymentsStore, RegularPaymentInstructionStore } from "./Store/Variable";
import { QuoteErrors } from "../../../../../Wrap/Validation/Errors/Quote/QuoteErrors";
import { OrderType } from "../../../../../Wrap/Constants/Enums/Domain/OrderType";
import { CashPayment } from "../../../../../Wrap/Models/Models/PortfolioAnalysis/Payment/CashPayment";
import { PaymentSource } from "../../../../../Wrap/Constants/Enums/Domain/PaymentSource";
import { CurrencyCode } from "../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { InstructionType } from "../../../../../Wrap/Models/Models/PortfolioAnalysis/Payment/InstructionType";
import { PaymentStatus } from "../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/PaymentStatus";
import { DistributionDividendPreference } from "../../../../../Wrap/Constants/Enums/Domain/DistributionDividendPreference";


interface IRegularPaymentWizardState extends IAccountContextWizardComponentState {
    extraInfo: {
        hasCashIsa: boolean;
        treasuredAssetProductIds: number[];
        treasuredAssetsInstructionId: number;
    };
    isInstructionLoading: boolean;
    autoLineCompleted: boolean;
}

export class RegularPaymentWizard extends AccountContextWizardComponent<IRegularPaymentWizardState> {
    initState() {
        this.state = {
            data: null,
            errorMsg: [],
            isShowErrorMsg: false,
            onPosting: false,
            active: true,
            isLoading: true,
            isSubmitting: false,
            customer: null,
            clientAccount: null,
            extraInfo: {
                hasCashIsa: false,
                treasuredAssetProductIds: null,
                treasuredAssetsInstructionId: null,
            },
            isInstructionLoading: false,
            autoLineCompleted: true,
            orderType: OrderType.Percentage
        };
    }

    constructor(props: any) {
        super(props);
        this.subscribeToStore(RegularPaymentInstructionStore, () => this.onInstructionStoreChange());
        this.subscribeToStore(ExistingRegularPaymentsStore, () => this.onExistingRegularPaymentsStoreChange());
        this.subscribeToStore(ExistingIndexationsStore, () => this.onExistingIndexationsStoreChange());
    }

    componentDidMount() {
        super.componentDidMount();

        const params = getQueryParameters();
        const hierarchyId = params["hierarchyid"];
        this.getProductDetails(hierarchyId);

        RegularPaymentAction.getExistingRegularPayments(params["subaccounthierarchyid"]);
        RegularPaymentAction.getIndexation(params["subaccounthierarchyid"]);
    }

    componentDidUpdate(prevProps) {
        const { clientAccount, customer, isInstructionLoading } = this.state;
        if (clientAccount && customer && !this.state.data && !isInstructionLoading) {
            const action = getQueryParameters()["action"];
            const hierarchyId = getQueryParameters()["hierarchyid"];
            const subAccountHierarchyId = getQueryParameters()["subaccounthierarchyid"];
            const id = getQueryParameters()["id"];
            const type = Number(getQueryParameters()["type"]);
            this.setState({ isInstructionLoading: true });
            RegularPaymentAction.getInstruction(
                id,
                type,
                hierarchyId,
                subAccountHierarchyId,
                this.state.customer?.CustomerId,
                action
            );
        }
        this.checkDistributionDividendOptions();
    }

    onClientAccountStoreChange() {
        super.onClientAccountStoreChange();
        if (this.state.clientAccount) {
            const type = Number(getQueryParameters()["type"]);
            if (type === SubAccountType.StocksIsa) {
                const extraInfo = this.state.extraInfo;
                extraInfo.hasCashIsa = this.state.clientAccount.SubAccounts.some(
                    (ele) => ele.ProductDisplayName == "ISA Cash"
                );
                this.setState({ extraInfo: extraInfo });
            }
        }
    }

    private onInstructionStoreChange() {
        if (RegularPaymentInstructionStore.getActionType() == ActionType.Success) {
            const batchId = getQueryParameters()["batchid"];
            var updatedData = RegularPaymentInstructionStore.getData();

            const {data, isLoading} = this.populateExistingPaymentInfo();
            if (data) {
                updatedData = data;
            }

            if (updatedData.Contribution?.PreRetirementInstrumentSelections?.Instruments?.length > 0) {
                updatedData = this.syncAllocation(updatedData);
            }
            this.setState({
                isLoading: isLoading,
                data: updatedData.Errors != null && updatedData.Errors.length > 0 ? this.state.data : updatedData,
                active: updatedData?.Status === InstructionStatus.Pending || updatedData?.Status === InstructionStatus.NotSpecified,
                isInstructionLoading: isLoading,
            });
            const isEdit = getQueryParameters()["action"] === RegularPaymentActionType.Edit;
            isEdit && this.checkRegularPaymentAutoLine();
        } else if (RegularPaymentInstructionStore.getActionType() == ActionType.Update) {
            const extraInfo = this.state.extraInfo;
            extraInfo.hasCashIsa = RegularPaymentInstructionStore.getHasCashIsa();
            this.setState({
                extraInfo: extraInfo,
            });
        }
    }

    private onExistingRegularPaymentsStoreChange() {
        const {data, isLoading} = this.populateExistingPaymentInfo();
        const newState = {};
        if (isLoading == false) {
            newState["isLoading"] = false;
            newState["isInstructionLoading"] = false;
        }
        if (data) {
            newState["data"] = data;
        }

        if (Object.keys(newState).length > 0) {
            this.setState(newState);
        }
    }

    private onExistingIndexationsStoreChange() {
        const {data, isLoading} = this.populateExistingPaymentInfo();
        const newState = {};
        if (isLoading == false) {
            newState["isLoading"] = false;
            newState["isInstructionLoading"] = false;
        }
        if (data) {
            newState["data"] = data;
        }

        if (Object.keys(newState).length > 0) {
            this.setState(newState);
        }
    }

    private populateExistingPaymentInfo() {
        if (ExistingRegularPaymentsStore.getActionType() == ActionType.Success
                && ExistingIndexationsStore.getActionType() == ActionType.Success) {
            const isLoading = RegularPaymentInstructionStore.isLoading();
            if (!isLoading) {
                const data = RegularPaymentInstructionStore.getData();
                const batchId = getQueryParameters()["batchid"];
                const existingRegularPayments = ExistingRegularPaymentsStore.getData() || [];
                const existingIndexations = ExistingIndexationsStore.getData() || [];
                if (batchId) {
                    if (data?.Contribution?.ClientRegularPayment?.RegularBuyId != batchId){
                        const targetClientRegularPayment = existingRegularPayments.find(e =>
                            e.InstructionType == InstructionType.Standing && e.Status == PaymentStatus.Authorised&&
                            (e.Source == PaymentSource.NotSpecified || e.Source == PaymentSource.Employee) && (e.BatchId == batchId));
                        if (targetClientRegularPayment) {
                            data.Contribution.ClientRegularPayment = this.PopulateRegularContribution(targetClientRegularPayment, existingIndexations)
                        }
                        else {
                            data.Contribution.ClientRegularPayment = null;
                        }
                    }

                    if (data?.Contribution?.EmployerRegularPayment?.RegularBuyId != batchId){
                        const targetEmployerRegularPayment = existingRegularPayments.find(e =>
                            e.InstructionType == InstructionType.Standing && e.Status == PaymentStatus.Authorised&&
                            e.Source == PaymentSource.Employer && (e.BatchId == batchId));
                        if (targetEmployerRegularPayment) {
                            data.Contribution.EmployerRegularPayment = this.PopulateRegularContribution(targetEmployerRegularPayment, existingIndexations)
                        }
                        else {
                            data.Contribution.EmployerRegularPayment = null;
                        }
                    }

                    if (data?.Contribution?.ThirdPartyRegularPayment?.RegularBuyId != batchId){
                        const targetThirdPartyRegularPayment = existingRegularPayments.find(e =>
                            e.InstructionType == InstructionType.Standing && e.Status == PaymentStatus.Authorised&&
                            e.Source == PaymentSource.ThirdParty && (e.BatchId == batchId));
                        if (targetThirdPartyRegularPayment) {
                            data.Contribution.ThirdPartyRegularPayment = this.PopulateRegularContribution(targetThirdPartyRegularPayment, existingIndexations)
                        }
                        else {
                            data.Contribution.ThirdPartyRegularPayment = null;
                        }
                    }

                    if (data?.Contribution?.EmployerSalaryDeductionRegularPayment?.RegularBuyId != batchId){
                        const targetEmployerSalaryDeductionRegularPayment = existingRegularPayments.find(e =>
                            e.InstructionType == InstructionType.Standing && e.Status == PaymentStatus.Authorised&&
                            e.Source == PaymentSource.EmployerSalaryDeduction && (e.BatchId == batchId));
                        if (targetEmployerSalaryDeductionRegularPayment) {
                            data.Contribution.EmployerSalaryDeductionRegularPayment = this.PopulateRegularContribution(targetEmployerSalaryDeductionRegularPayment, existingIndexations)
                        }
                        else {
                            data.Contribution.EmployerSalaryDeductionRegularPayment = null;
                        }
                    }
                }
                return {
                    data: data,
                    isLoading: false,
                };
            }
        }
        return {};
    }

    private PopulateRegularContribution(targetRegularPayment : any, existingIndexations : any){
        var regularPayment = {
            RegularBuyId: targetRegularPayment.BatchId,
            FirstCollectionDate: targetRegularPayment.FirstDate,
            Money: { Amount: targetRegularPayment.Amount, Currency: CurrencyCode.GBP },
            Frequency: targetRegularPayment.Frequency,
            BankAccountNumber: targetRegularPayment.BankAccountNumber,
            RegularPaymentMethod: targetRegularPayment.Method,
            TaxRelief: targetRegularPayment.TaxRelief,
            WasPaymentChanged: false,
            NextPaymentDate: targetRegularPayment.NextDate,
            Indexation : null,
            SourceOfFunds: targetRegularPayment.SourceOfFunds,
            OriginCountry: targetRegularPayment.OriginCountry
        }

        const subAccountType = Number(getQueryParameters()["type"]);
        if (SubAccountTypeHelper.isOnPlatformPension(subAccountType) && existingIndexations && this.stepperConfig.length == 0) {
            regularPayment.Indexation = existingIndexations.find(e => e.CashEntryId == targetRegularPayment.Id) ?? null;
        }

        return regularPayment
    }

    private getProductDetails(hierarchyId: string) {
        const _date = JsonDateParser.getFormatDateString(new Date(), "yyyy/MM/dd") as any;
        const wrapcash = ProductDetailsStore.getSubAccount(SubAccountType.WrapCash);

        if (!wrapcash) {
            Action.getProductsValuationDetailSummary(hierarchyId, null, _date);
        }
    }

    private checkDistributionDividendOptions(){
        if(this.state.data?.Contribution?.DistributionDividendOptions?.DistributionDividendPreference != null &&
            this.state.data.Contribution.DistributionDividendOptions.DistributionDividendPreference == DistributionDividendPreference.NotSpecified){
            this.state.data.Contribution.DistributionDividendOptions.DistributionDividendPreference = DistributionDividendPreference.ProductCash;
        }
    }

    private checkRegularPaymentAutoLine() {
        const regularBuyId = getQueryParameters()["batchid"] ?? this.state.data?.Contribution?.ClientRegularPayment?.RegularBuyId;

        if(!regularBuyId) {return false;}

        RegularPaymentAction.checkRegularPaymentAutolineCompleted(regularBuyId, (result) => {
            if (result?.Id === QuoteErrors.DirectDebitCanNotBeChangedBecauseLastAutoLineIsNotCompleted) {
                this.setState({
                    errorMsg: [result.Description],
                    isShowErrorMsg: true,
                });
                this.setState({ autoLineCompleted: false });
            }
        });
    }

    saveInstruction(from, to, toUrl, params) {
        if (!params["id"]) {
            params["id"] = this.state.data.HierarchyId;
            SPTAction.postInstructionProcess(
                HierarchyIdHelper.generateHierarchyId(this.state.data.HierarchyId).entityId,
                params["action"] === RegularPaymentActionType.Edit
                    ? ProcessType.EditRegularPayment
                    : ProcessType.AddRegularPayment
            );
        }
        const { customer } = this.state;

        RegularPaymentAction.saveInstruction(
            from,
            this.state.data,
            parseInt(params["type"]),
            customer?.CustomerId,
            (result) => {
                this.setState({ onPosting: false });
                if (result?.length > 0) {
                    this.setState({
                        errorMsg: result.map((x) => x.UserMessage),
                        isShowErrorMsg: true,
                    });
                } else {
                    if (this.state.extraInfo.treasuredAssetsInstructionId) {
                        Action.setInstructionTreasuredAssetsProductIds(
                            this.state.extraInfo.treasuredAssetsInstructionId,
                            this.state.extraInfo.treasuredAssetProductIds,
                            () => {
                                this.setState({ onPosting: false });
                                this.navigate(to, toUrl, params);
                            }
                        );
                    } else {
                        this.setState({ onPosting: false });
                        this.navigate(to, toUrl, params);
                    }
                }
            }
        );
    }

    private navigate(to, toUrl, params) {
        if (to == -1) {
            this.onExit();
        } else {
            Navigator.navigateTo(toUrl, {
                queryParamsObject: params,
                scrollAfterNavigating: true,
            });
        }
    }

    onCancel() {
        // RegularPaymentAction.deleteInstruction(this.state.data.HierarchyId, () => this.onExit());
        // SLP-70599
        this.onExit();
    }

    onExit() {
        const accountRoles = AccountRoleStore.getAccountRoles();
        const clientAccount = ClientAccountStore.getClientAccountInfo();
        RoutingActions.navigateTo(getUrl(clientAccount, accountRoles, "summary"));
    }

    onSubmit() {
        this.setState({ isSubmitting: true, active: false, isShowErrorMsg: false, errorMsg: [] });
        RegularPaymentAction.submitInstruction(
            this.state.data.HierarchyId,
            this.state.data.Contribution,
            this.state.data.ClientDetails.ActorId,
            this.state.data.SubAccountClientDetail.ClAccountId,
            Number(getQueryParameters()["type"]),
            () => {
                this.setState({ isSubmitting: false });
                const params = getQueryParameters();
                const instructionId = HierarchyIdHelper.generateHierarchyId(this.state.data.HierarchyId).entityId;
                SPTAction.cancelCommissionCharges(
                    instructionId,
                    params["hierarchyid"],
                    params["subaccounthierarchyid"],
                    this.state.data.Contribution.CancelAllCommissionCharges
                );
            }
        );
    }

    onTreasuredAssetsStoreChange() {
        const treasuredAssetProductIds = TreasuredAssetsStore.getTreasuredAssetsProductIds();
        this.setState({
            extraInfo: {
                hasCashIsa: this.state.extraInfo.hasCashIsa,
                treasuredAssetProductIds: treasuredAssetProductIds,
                treasuredAssetsInstructionId: null,
            },
        });
    }

    onChangeTreasuredAssets(hierarchyId: string, productId: number, value: boolean) {
        let productIds = this.state.extraInfo.treasuredAssetProductIds;
        if (value) {
            productIds.push(productId);
        } else {
            productIds = productIds.filter((id) => id !== productId);
        }
        this.setState({
            extraInfo: {
                hasCashIsa: this.state.extraInfo.hasCashIsa,
                treasuredAssetProductIds: productIds,
                treasuredAssetsInstructionId: HierarchyIdHelper.generateHierarchyId(hierarchyId).entityId,
            },
        });
    }

    private getTotalClientRegularPaymentAmount = (data) => {
        return (data?.ClientRegularPayment?.TaxRelief ? 1.25 : 1) * data?.ClientRegularPayment?.Money?.Amount || 0;
    }

    private getTotalThirdPartyRegularPaymentAmount = (data) => {
        return (data?.ThirdPartyRegularPayment?.TaxRelief ? 1.25 : 1) * data?.ThirdPartyRegularPayment?.Money?.Amount || 0;
    }

    private getTotalEmployerRegularPaymentAmount = (data) => {
        return (data?.EmployerRegularPayment?.TaxRelief ? 1.25 : 1) * data?.EmployerRegularPayment?.Money?.Amount || 0;
    }

    private getTotalEmployerSalaryDeductionRegularPaymentAmount = (data) => {
        return (data?.EmployerSalaryDeductionRegularPayment?.TaxRelief ? 1.25 : 1) * data?.EmployerSalaryDeductionRegularPayment?.Money?.Amount || 0;
    }

    private syncAllocation(data) {
        (data.Contribution.PreRetirementInstrumentSelections.Instruments).forEach((ele, index) => {
            if (data.Contribution.PreRetirementInstrumentSelections.Instruments[index].ClientRegular?.Money) {
                const totalPaymentAmount = this.getTotalClientRegularPaymentAmount(data?.Contribution);
                data.Contribution.PreRetirementInstrumentSelections.Instruments[index].ClientRegular.Money.Amount = ele.ClientRegular.Percentage * totalPaymentAmount / 100;
            }

            if (data.Contribution.PreRetirementInstrumentSelections.Instruments[index].ThirdPartyRegularPayment?.Money) {
                const totalPaymentAmount = this.getTotalThirdPartyRegularPaymentAmount(data?.Contribution);
                data.Contribution.PreRetirementInstrumentSelections.Instruments[index].ThirdPartyRegularPayment.Money.Amount = ele.ThirdPartyRegularPayment.Percentage * totalPaymentAmount / 100;
            }

            if (data.Contribution.PreRetirementInstrumentSelections.Instruments[index].EmployerSalaryDeductionRegularPayment?.Money) {
                const totalPaymentAmount = this.getTotalEmployerRegularPaymentAmount(data?.Contribution);
                data.Contribution.PreRetirementInstrumentSelections.Instruments[index].EmployerSalaryDeductionRegularPayment.Money.Amount = ele.EmployerSalaryDeductionRegularPayment.Percentage * totalPaymentAmount / 100;
            }

            if (data.Contribution.PreRetirementInstrumentSelections.Instruments[index].EmployerSalaryDeductionRegularPayment?.Money) {
                const totalPaymentAmount = this.getTotalEmployerSalaryDeductionRegularPaymentAmount(data?.Contribution);
                data.Contribution.PreRetirementInstrumentSelections.Instruments[index].EmployerSalaryDeductionRegularPayment.Money.Amount = ele.EmployerSalaryDeductionRegularPayment.Percentage * totalPaymentAmount / 100;
            }
        })
        return data;
    }

    getStepProps(index) {
        const { active } = this.state;
        const stepProps = super.getStepProps(index);
        stepProps.isReview = !active;
        return stepProps;
    }

    private setReviewConfirmSteppers() {
        const type = Number(getQueryParameters()["type"]);
        const len = this.stepperConfig.length;
        const { customer } = this.state;
        return [
            {
                title: RegularPaymentSteppersMap.review,
                url: Urls.get().RegularPaymentReview,
                path: Contents.URLMap.review,
                onStepLeave: (from, to) => {
                    this.onStepperLeave(from, to);
                },
                needPrint: true,
                component: <Review {...this.getStepProps(len)} type={type} />,
            },
            {
                title: RegularPaymentSteppersMap.doc,
                url: Urls.get().RegularPaymentDoc,
                path: Contents.URLMap.documentAndDeclarations,
                onSubmit: () => this.onSubmit(),
                canSubmit: () => this.child[this.stepperConfig.length - 2].isValid(),
                onStepLeave: (from, to) => {
                    this.onStepperLeave(from, to);
                },
                component: (
                    <DocumentsAndDeclarations
                        subAccountType={type}
                        {...this.getStepProps(len + 1)}
                        processType={processTypeEnum.RegularPayment}
                        clAccountId={this.state.clientAccount?.HeadClAccountId}
                        isJointOrTrust={isJointOrTrustAccount(this.state.clientAccount?.InvestorType)}
                        customerId={customer.CustomerId}
                    />
                ),
            },
            {
                title: RegularPaymentSteppersMap.comfirm,
                url: Urls.get().RegularPaymentConfirm,
                path: Contents.URLMap.confirmation,
                type: StepType.Confirmation,
                component: (
                    <Confirmation
                        onExit={() => this.onExit()}
                        successMessage={`We've received your instruction to set up a regular payment`}
                        isLoading={this.state.isSubmitting}
                        accountNumberMessage={`(${this.state.clientAccount?.HeadClAccountId})`}
                    />
                ),
            },
        ];
    }

    setStepperConfig() {
        const type = Number(getQueryParameters()["type"]);
        const isEdit = getQueryParameters()["action"] === RegularPaymentActionType.Edit;
        const { Contribution } = this.state.data;
        const { customer } = this.state;
        const { autoLineCompleted } = this.state;
        const steppers = [
            {
                title: RegularPaymentSteppersMap.paymentsIn,
                url: Urls.get().RegularPaymentsIn,
                path: Contents.URLMap.paymentIn,
                onStepLeave: (from, to) => {
                    this.onStepperLeave(from, to);
                },
                component: (
                    <PaymentsIn
                        {...this.getStepProps(0)}
                        type={type}
                        hasCashIsa={this.state.extraInfo.hasCashIsa}
                        isEdit={isEdit}
                        customerId={customer?.CustomerId}
                        autoLineCompleted={autoLineCompleted}
                    />
                ),
            },
        ];
        if (!SubAccountTypeHelper.isCashAccount(type)) {
            steppers.push({
                title: RegularPaymentSteppersMap.adviserCharges,
                url: Urls.get().RegularPaymentAdviserCharge,
                path: Contents.URLMap.adviserCharges,
                onStepLeave: (from, to) => {
                    this.onStepperLeave(from, to);
                },
                component: <AdviserCharges {...this.getStepProps(1)} type={type} />,
            });
            if (type !== SubAccountType.CashIsa && hasRegularPayments(Contribution)) {
                steppers.push({
                    title: RegularPaymentSteppersMap.investment,
                    url: Urls.get().RegularPaymentIst,
                    path: Contents.URLMap.ist,
                    onStepLeave: (from, to) => {
                        this.onStepperLeave(from, to);
                    },
                    component: (
                        <InvestmentSelectionTool
                            {...this.getStepProps(2)}
                            type={type}
                            treasuredAssetProductIds={this.state.extraInfo.treasuredAssetProductIds}
                            onTreasuredAssetsStoreChange={() => this.onTreasuredAssetsStoreChange()}
                            onChangeTreasuredAssets={(subAccountInstructionId, productId, value) => {
                                this.onChangeTreasuredAssets(subAccountInstructionId, productId, value);
                            }}
                            orderType={this.state.orderType}
                            onOrderTypeChange={(value) => this.setState({ orderType: value })}
                        />
                    ),
                });
            }
        }
        this.stepperConfig = steppers;
        this.stepperConfig = this.stepperConfig.concat(this.setReviewConfirmSteppers());
    }

    setProcessProps() {
        const { data } = this.state;
        const type = Number(getQueryParameters()["type"]);
        const processProps = super.setProcessProps();
        processProps.needSplitHeader = {
            fromStep: 0,
            splitHeaderMain: ClientNameHelper.clientNameDisplay(data?.ClientDetails, data?.SecondClientDetails),
            splitHeaderSub: this.state.clientAccount?.HeadClAccountId,
        };
        processProps.processTitle =
            getQueryParameters()["action"] === RegularPaymentActionType.Edit
                ? "Edit regular payment instruction(s)"
                : "Add regular payment instruction(s)";
        processProps.subTitle = productMap[type];
        return processProps;
    }
}
